import script from "./PartnerDeleteBulkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerDeleteBulkModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/account.css?vue&type=style&index=0&id=7c420f86&scoped=true&lang=css&external"
import "./PartnerDeleteBulkModal.vue?vue&type=style&index=1&id=7c420f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c420f86"]])

export default __exports__